<template>
    <div>
        <h4>Potencjalnie zainteresowane firmy</h4>
        <div style="position: relative;">
            <Loader :loading="loading" />
            <ValidationObserver ref="observer" v-if="showSearch">
                <v-row>
                    <v-col cols="10">
                        <ValidationProvider ref="postCodes" rules="postCodeList|required" name="Kody pocztowe" slim v-slot="{ errors }">
                            <v-text-field
                                v-model="postCodes"
                                label="Wpisz kody pocztowe"
                                :error-messages="errors"
                            />
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="2">
                        <v-btn @click="loadCompanies" color="primary" block>Wyszukaj</v-btn>
                    </v-col>
                </v-row>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import api from '../../services/api';
    import Loader from '../Loader';
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import { initValidators } from '@/lib/validation/initValidators';
    import postCodeList from '../../lib/validation/rules/postCodeList';
    import {required} from 'vee-validate/dist/rules';

    initValidators({
        required: required,
        postCodeList: postCodeList,
    });

    export default {
        components: { Loader, ValidationObserver, ValidationProvider },
        props: ['saleOfferId', 'orderId', 'showSearch'],
        data() {
            return {
                loading: false,
                postCodes: '',
            }
        },
        created() {
          if (!this.showSearch) {
            this.loadCompanies();
          }
        },
        methods: {

            async loadCompanies() {
                if (this.showSearch) {
                  const validationResult = await this.$refs['postCodes'].validate();

                  if (!validationResult.valid) {
                    return;
                  }

                }

                this.loading = true;
                this.$emit('search-start');

                let params = {};

                if (this.saleOfferId) {
                  params = {
                    saleOfferId: this.saleOfferId,
                    type: 'others'
                  }
                }

                if (this.orderId) {
                  params = {
                    orderId: this.orderId,
                  }
                }

                if (this.showSearch) {
                  params['postCodes'] = this.postCodes.split(',');
                }

                const response = await api.get(`/api/companies/potentially-interested`, {
                    params
                });
                const data = response.data;

                this.loading = false;
                this.$emit(
                    'search-complete',
                    data
                );
            }
        }
    }
</script>

<style scoped>

</style>